import { FC } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
// import { Wallet } from "views/Wallet";
import { Layout, Tabs } from "antd";
import "antd/dist/antd.css";
import "./style.css";

// import { DEX } from "views/DEX";
// import ERC20Balances from "views/ERC20Balances";
// import Ramper from "views/Ramper";
// import NFTBalance from "views/NFTBalance";
// import { Contract } from "views/Contract";
// import { ERC20Transfers } from "views/ERC20Transfers";
// import QuickStart from "views/QuickStart";
import Home from "components/Home";
import GeneralInfo from "components/GeneralInfo";
import CommunityProjects from "components/CommunityProjects";
import GlobalFooter from "components/GlobalFooter";
import GlobalHeader from "components/GlobalHeader";
import Dexscreener from "components/Dexscreener";
import GoodBridging from "components/GoodBridging";

const styles = {
  content: {
    display: "flex",
    justifyContent: "center",
    fontFamily: "Roboto, sans-serif",
    color: "#041836",
    marginTop: "63px",
  },
  headerMenu: {
    color: "#000000",
    backgroundColor: "none",
  },
  header: {
    position: "fixed",
    zIndex: 1,
    width: "100%",
    background: "#fff",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontFamily: "Roboto, sans-serif",
    borderBottom: "2px solid rgba(0, 0, 0, 0.06)",
    padding: "0 10px",
    boxShadow: "0 1px 10px rgb(151 164 175 / 10%)",
    backgroundColor: "#191d44",
  },
  footer: {
    backgroundColor: "rgba(31, 36, 79)",
    textAlign: "center",
    color: "white",
  },
  headerRight: {
    display: "flex",
    gap: "20px",
    alignItems: "center",
    fontSize: "15px",
    fontWeight: "600",
  },
};
interface AppProps {
  isServerInfo: boolean;
}
const App: FC<AppProps> = ({ config }) => {
  return (
    <Layout
      style={{ height: "100vh", overflow: "auto", background: "#191d44" }}
    >
      <Router>
        <GlobalHeader />
        <div style={styles.content}>
          <Switch>
            <Route exact path="/">
              <Home />
            </Route>

            <Route path="/dexscreener">
              <Dexscreener />
            </Route>

            <Route path="/analytics">
              <GeneralInfo config={config} />
            </Route>

            <Route path="/bridging">
              <GoodBridging />
            </Route>

            <Route path="/community-projects">
              <CommunityProjects />
            </Route>
          </Switch>
        </div>
      </Router>
      <GlobalFooter />
    </Layout>
  );
};

export default App;
